import { Button, ConfirmInfo, IconButton } from '@coop/components';
import { PaperIcon } from '@coop/icons';
import React from 'react';

import { Helpers } from '../../../../utility/helpers';
import { useIsMobile } from '../../../common/components/atoms/ResponsiveBreakpoints';
import useModal from '../../../common/hooks/useModal';
import type { SharedRecipe } from '../../models';

interface SharedBetweenRecipesPopupProps {
    sectionType: 'shared' | 'common';
    belongsToRecipes: SharedRecipe[];
}

const SharedBetweenRecipesPopup = (props: SharedBetweenRecipesPopupProps) => {
    const { close, isOpen, open } = useModal();

    const isMobile = useIsMobile();

    if (props.belongsToRecipes.length === 0) return null;

    const recipeNamesJoinedText = props.belongsToRecipes.map((recipe, index, array) => {
        return (
            <React.Fragment key={recipe.code}>
                {index > 0 && !(index === array.length - 1) ? ', ' : ''}
                {index > 0 && index === array.length - 1 ? ' och ' : ''}
                <span className="u-textUnderline">{recipe.name}</span>
            </React.Fragment>
        );
    });

    switch (props.sectionType) {
        case 'shared':
            return (
                <ConfirmInfo
                    show={isOpen}
                    close={close}
                    heading="Varan delas mellan recept"
                    bodySlot={
                        <div className="u-textCenter">
                            Den här produkten delas mellan recepten {recipeNamesJoinedText}.
                        </div>
                    }
                    renderTrigger={(ref) =>
                        isMobile ? (
                            <IconButton
                                ref={ref}
                                icon={PaperIcon}
                                theme="white"
                                size={32}
                                onClick={open}
                                label="Delas mellan recept"
                            />
                        ) : (
                            <Button
                                ref={ref}
                                theme="white"
                                size={32}
                                icon={PaperIcon}
                                onClick={open}
                            >
                                Delas mellan recept
                            </Button>
                        )
                    }
                />
            );
        case 'common':
            return (
                <ConfirmInfo
                    show={isOpen}
                    close={close}
                    heading="Varan ingår i flera recept"
                    bodySlot={
                        <div className="u-textCenter">
                            Den här produkten ingår i recepten {recipeNamesJoinedText}.
                        </div>
                    }
                    renderTrigger={
                        (ref) => (
                            // TODO: When we get copy texts. When available also uncomment IsCommonRecipeProduct story in RecipeProductListingItem.stories.tsx
                            // isMobile ? (
                            <IconButton
                                ref={ref}
                                icon={PaperIcon}
                                theme="white"
                                size={32}
                                onClick={open}
                                label=""
                            />
                        )
                        // ) : (
                        //     <Button
                        //         ref={ref}
                        //         theme="white"
                        //         size={32}
                        //         icon={PaperIcon} width={16} height={16}
                        //         onClick={open}
                        //     >
                        //     </Button>
                        // )
                    }
                />
            );

        default:
            return Helpers.exhaustiveCheck(props.sectionType);
    }
};

export default SharedBetweenRecipesPopup;
